var escape = require("../../../../css-loader/lib/url/escape.js");
exports = module.exports = require("../../../../css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "@media screen and (min-width:1200px){.vehicle .price-card.price-card-placeholder{background-color:#f1f1f1;background-image:url(" + escape(require("../images/gm-icon-white.svg")) + ");background-repeat:no-repeat;background-position:50%;border:0}.vehicle:nth-child(2n) .price-card.price-card-placeholder{background-color:#fff;background-image:url(" + escape(require("../images/gm-icon-grey.svg")) + ")}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/sass-loader/lib/loader.js!./node_modules/greenmotion-shared/Components/quotes/scss/price-card-placeholder.scss
// module id = Y6Im
// module chunks = 22